/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_SurgeryInputs */

const en_us2_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surgery`)
};

const pt_br2_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cirurgia`)
};

const es_419_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cirugía`)
};

const pt_pt2_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cirurgia`)
};

const fr_fr2_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chirurgie`)
};

const de_de2_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operation`)
};

const it_it2_bodymap_type_surgery = /** @type {(inputs: Bodymap_Type_SurgeryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervento chirurgico`)
};

/**
* | output |
* | --- |
* | "Surgery" |
*
* @param {Bodymap_Type_SurgeryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_surgery = /** @type {((inputs?: Bodymap_Type_SurgeryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_SurgeryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_surgery(inputs)
	if (locale === "es-419") return es_419_bodymap_type_surgery(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_surgery(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_surgery(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_surgery(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_surgery(inputs)
	return en_us2_bodymap_type_surgery(inputs)
});
export { bodymap_type_surgery as "bodymap.type.surgery" }